import { ElementProps } from '@/components/sections/builder/types';
import {
  HeroElementDataType,
  HeroSubtitleElementDataType,
} from '@/components/sections/builder/elements/body/hero/types';
import InputTab from '@/components/sections/builder/settings/input-tab';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { shallow } from 'zustand/shallow';
import { Type } from 'lucide-react';
import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';

const defaultData: HeroSubtitleElementDataType = {
  name: 'Sub Title',
  label:
    'From checkout to global sales tax compliance, companies around the world use Flowbite to simplify their payment stack.',
  textStyle: 'subtitle',
  padding: {
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
  },
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as HeroSubtitleElementDataType;
  const parentData = (element.parentData || {}) as HeroElementDataType;

  return (
    <>
      <p
        className={clsx(
          'hero-subtitle-padding hero-subtitle-default-color inline-block max-w-2xl text-left',
          data.textStyle === 'body' && 'text-base md:text-lg lg:text-xl',
          data.textStyle === 'subtitle' && 'text-sm md:text-base lg:text-lg',
          data.textStyle === 'uppercase' && 'text-xs uppercase md:text-sm lg:text-base'
        )}
        data-animation='true'
        dangerouslySetInnerHTML={{ __html: data.label }}
      />
      <style jsx>
        {`
          @media (min-width: 1024px) {
            .hero-subtitle-padding {
              padding-top: ${data.padding?.top || 0}px;
              padding-bottom: ${data.padding?.bottom || 0}px;
              padding-left: ${data.padding?.left || 0}px;
              padding-right: ${data.padding?.right || 0}px;
            }
          }
          .hero-subtitle-default-color {
            color: ${parentData.colorScheme?.text || 'text-gray-500'};
          }
        `}
      </style>
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as HeroSubtitleElementDataType;

  return (
    <div>
      <div className='mb-4 font-bold'>Text</div>

      <TextEditorMinimal
        value={data.label}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, { label: val });
        }}
        output='html'
        className='mb-2 w-full '
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
        placeholder='Label'
      />
      <div className='mb-4 mt-4 font-bold'>Text Style</div>
      <InputTab
        defaultValue={data.textStyle}
        options={[
          { label: 'Body', value: 'body' },
          { label: 'Subtitle', value: 'subtitle' },
          { label: 'UPPERCASE', value: 'uppercase' },
        ]}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            textStyle: v,
          })
        }
      />
      <PaddingSetting
        value={data.padding}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            padding: v,
          })
        }
      />
    </div>
  );
}

const HeroSubtitle = {
  type: 'hero_subtitle',
  group: 'hero',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default HeroSubtitle;
